import { BigNumber } from '@ethersproject/bignumber';
import { BIG_ZERO } from '../../constants';

export const sum = (numbers: BigNumber[]) => numbers.reduce((total, number) => total.add(number), BIG_ZERO);
